import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  fetchImageSlidersList,
  applyImageSliderDrag,
  clearImageSliderDrag,
  clearPatchImageSlider,
  clearDeleteImageSlider,
  clearAddImageSlider,
  clearVerifyInstagramAccount,
  clearPatchDetailsForImageSlider,
} from 'redux/image-sliders/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import { Loader } from 'semantic-ui-react';

import CommonImageSlider
  from 'components/dashboard/image-slider/common-slider/CommonImageSlider';
import InstagramSliderItem
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderItem';
import CommonMessage from 'components/common/CommonMessage';

import './ImageSlidersList.css';


class ImageSlidersList extends Component {
  static propTypes = {
    fetchImageSlidersList: PropTypes.func.isRequired,
    applyImageSliderDrag: PropTypes.func.isRequired,
    clearImageSliderDrag: PropTypes.func.isRequired,
    clearPatchImageSlider: PropTypes.func.isRequired,
    clearDeleteImageSlider: PropTypes.func.isRequired,
    clearAddImageSlider: PropTypes.func.isRequired,
    clearVerifyInstagramAccount: PropTypes.func.isRequired,
    clearPatchDetailsForImageSlider: PropTypes.func.isRequired,
    imageSlidersList: PropTypes.arrayOf(PropTypes.shape),
    imageSlidersListError: PropTypes.object,
    dragImageSliderSuccess: PropTypes.object,
    patchImageSliderSuccess: PropTypes.object,
    deleteImageSliderSuccess: PropTypes.object,
    verifyInstagramAccountSuccess: PropTypes.object,
    patchDetailsForImageSliderSuccess: PropTypes.object,
  };

  static defaultProps = {
    imageSlidersList: null,
    imageSlidersListError: null,
    dragImageSliderSuccess: null,
    patchImageSliderSuccess: null,
    deleteImageSliderSuccess: null,
    verifyInstagramAccountSuccess: null,
    patchDetailsForImageSliderSuccess: null,
  };

  state = {
    items: null,
  };

  componentDidMount() {
    this.setState({ items: this.props.imageSlidersList });
  }

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.imageSlidersList !== this.props.imageSlidersList) {
      this.setState({ items: this.props.imageSlidersList });
    }

    // Drag and Drop
    if (
      !prevProps.dragImageSliderSuccess &&
      prevProps.dragImageSliderSuccess !== this.props.dragImageSliderSuccess
    ) {
      this.props.fetchImageSlidersList();
      this.props.clearImageSliderDrag();
    }

    // Patch
    if (
      !prevProps.patchImageSliderSuccess &&
      prevProps.patchImageSliderSuccess !== this.props.patchImageSliderSuccess
    ) {
      this.props.fetchImageSlidersList();
      this.props.clearPatchImageSlider();
    }

    // Delete
    if (
      !prevProps.deleteImageSliderSuccess &&
      prevProps.deleteImageSliderSuccess !== this.props.deleteImageSliderSuccess
    ) {
      this.props.fetchImageSlidersList();
      this.props.clearDeleteImageSlider();
      this.props.clearAddImageSlider();
    }

    // Verify Instagram Account
    if (
      !prevProps.verifyInstagramAccountSuccess &&
      prevProps.verifyInstagramAccountSuccess !== this.props.verifyInstagramAccountSuccess
    ) {
      this.props.fetchImageSlidersList();
      this.props.clearVerifyInstagramAccount();
    }

    // Patch Slider Image
    if (
      !prevProps.patchDetailsForImageSliderSuccess &&
      prevProps.patchDetailsForImageSliderSuccess !== this.props.patchDetailsForImageSliderSuccess
    ) {
      this.props.fetchImageSlidersList();
      this.props.clearPatchDetailsForImageSlider();
    }
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applyImageSliderDrag(form);
    });
  };

  renderCommonSlider = item => (
    <CommonImageSlider
      key={`common-image-slider-key-id-${item.id}`}
      item={item}
    />
  );

  renderInstagramSlider = item => (
    <InstagramSliderItem
      key={`instagram-slider-key-id-${item.id}`}
      item={item}
    />
  );

  renderImageSlidersList = () => {
    const { items } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      {item.slider_type === 'slider' && this.renderCommonSlider(item)}
                      {item.slider_type === 'instagram' && this.renderInstagramSlider(item)}
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { imageSlidersList, imageSlidersListError } = this.props;
    const { items } = this.state;

    return (
      <div className="image-sliders-list__component">
        {/* Loader */}
        {!imageSlidersList && !imageSlidersListError &&
          <Loader active />
        }

        {/* Image Sliders List */}
        {items && items.length > 0 &&
          this.renderImageSlidersList()
        }

        {/* Fetch Image Sliders Error */}
        {imageSlidersListError &&
          <CommonMessage
            error
            errors={imageSlidersListError}
          />
        }
      </div>
    );
  }
};

const mapStateToProps = state => (
  {
    imageSlidersList: state.imageSlidersReducer.imageSlidersList,
    imageSlidersListError: state.imageSlidersReducer.imageSlidersListError,
    dragImageSliderSuccess: state.imageSlidersReducer.dragImageSliderSuccess,
    patchImageSliderSuccess: state.imageSlidersReducer.patchImageSliderSuccess,
    deleteImageSliderSuccess: state.imageSlidersReducer.deleteImageSliderSuccess,
    verifyInstagramAccountSuccess: state.imageSlidersReducer.verifyInstagramAccountSuccess,
    patchDetailsForImageSliderSuccess: state.imageSlidersReducer.patchDetailsForImageSliderSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchImageSlidersList,
    applyImageSliderDrag,
    clearImageSliderDrag,
    clearPatchImageSlider,
    clearDeleteImageSlider,
    clearAddImageSlider,
    clearVerifyInstagramAccount,
    clearPatchDetailsForImageSlider,
  },
)(ImageSlidersList);
